module.exports = __webpack_public_path__ + "img/1787896145486123010.ec271c31.png";